import { html } from './h.js'

/**
 * One stroked icon set at a single weight, so the UI never mixes visual
 * languages. Everything is drawn on a 24-grid with 1.7px strokes and round
 * caps, which reads clearly at both 18px and 28px.
 */
function svg (path, { size = 20, fill = false, viewBox = '0 0 24 24' } = {}) {
  return html`
    <svg width=${size} height=${size} viewBox=${viewBox} fill=${fill ? 'currentColor' : 'none'}
         stroke=${fill ? 'none' : 'currentColor'} stroke-width="1.7"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      ${path}
    </svg>`
}

const p = (d) => html`<path d=${d} />`

export const Icon = {
  pine: (s) => svg(html`
    <path d="M12 3 5.5 12h3.2L4 19h16l-4.7-7h3.2L12 3Z" />
    <path d="M12 19v2.5" />`, { size: s }),

  chat: (s) => svg(p('M21 11.5a8.4 8.4 0 0 1-9 8.4 9.9 9.9 0 0 1-3.4-.6L3 21l1.7-4.6A8.4 8.4 0 1 1 21 11.5Z'), { size: s }),
  channel: (s) => svg(html`
    <path d="M4 9v6h4l6 4V5L8 9H4Z" />
    <path d="M18.5 8.5a5 5 0 0 1 0 7" />`, { size: s }),
  contacts: (s) => svg(html`
    <path d="M17 20v-1.5a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4V20" />
    <circle cx="9.5" cy="7" r="3.5" />
    <path d="M22 20v-1.5a4 4 0 0 0-3-3.87M16 3.6a4 4 0 0 1 0 7.75" />`, { size: s }),
  settings: (s) => svg(html`
    <circle cx="12" cy="12" r="3.2" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.56V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.56 1.7 1.7 0 0 0-1.88.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.55-1.1 1.7 1.7 0 0 0-.33-1.88l-.06-.06a2 2 0 1 1 2.82-2.83l.06.06a1.7 1.7 0 0 0 1.88.34H9a1.7 1.7 0 0 0 1-1.56V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.55 1.7 1.7 0 0 0 1.88-.33l.06-.06a2 2 0 1 1 2.83 2.82l-.06.06a1.7 1.7 0 0 0-.34 1.88V9a1.7 1.7 0 0 0 1.56 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />`, { size: s }),

  search: (s) => svg(html`<circle cx="11" cy="11" r="7" /><path d="m20 20-3.6-3.6" />`, { size: s }),
  plus: (s) => svg(p('M12 5v14M5 12h14'), { size: s }),
  close: (s) => svg(p('M18 6 6 18M6 6l12 12'), { size: s }),
  back: (s) => svg(p('M15 19l-7-7 7-7'), { size: s }),
  forward: (s) => svg(p('M9 5l7 7-7 7'), { size: s }),
  chevronDown: (s) => svg(p('M6 9l6 6 6-6'), { size: s }),
  more: (s) => svg(html`
    <circle cx="12" cy="5" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="12" cy="19" r="1.3" fill="currentColor" stroke="none" />`, { size: s }),

  send: (s) => svg(p('M4.5 12 20 4.5 15.5 20l-3.6-5.9L4.5 12Z'), { size: s }),
  attach: (s) => svg(p('M21 11.5 12.5 20a5 5 0 0 1-7-7l8.6-8.6a3.3 3.3 0 0 1 4.7 4.7l-8.6 8.5a1.7 1.7 0 0 1-2.4-2.4l7.9-7.8'), { size: s }),
  emoji: (s) => svg(html`
    <circle cx="12" cy="12" r="9" />
    <path d="M8.5 14.5a4.5 4.5 0 0 0 7 0" />
    <circle cx="9" cy="9.8" r=".9" fill="currentColor" stroke="none" />
    <circle cx="15" cy="9.8" r=".9" fill="currentColor" stroke="none" />`, { size: s }),
  mic: (s) => svg(html`
    <rect x="9" y="2.5" width="6" height="11.5" rx="3" />
    <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3.5" />`, { size: s }),
  camera: (s) => svg(html`
    <path d="M15.5 9.5V8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1.5l5 3.2V6.3l-5 3.2Z" />`, { size: s }),
  cameraOff: (s) => svg(html`
    <path d="M15.5 9.5V8a2 2 0 0 0-2-2H8m-4.3.6A2 2 0 0 0 3.5 8v8a2 2 0 0 0 2 2h8a2 2 0 0 0 1.4-.6M20.5 6.3v11.4l-5-3.2" />
    <path d="M3 3l18 18" />`, { size: s }),
  phone: (s) => svg(p('M21.5 16.9v2.6a1.8 1.8 0 0 1-2 1.8 17.9 17.9 0 0 1-7.8-2.8 17.6 17.6 0 0 1-5.4-5.4A17.9 17.9 0 0 1 3.5 5.2a1.8 1.8 0 0 1 1.8-2h2.6a1.8 1.8 0 0 1 1.8 1.5c.1.9.3 1.7.6 2.5a1.8 1.8 0 0 1-.4 1.9l-1.1 1.1a14.4 14.4 0 0 0 5.4 5.4l1.1-1.1a1.8 1.8 0 0 1 1.9-.4c.8.3 1.6.5 2.5.6a1.8 1.8 0 0 1 1.5 1.8Z'), { size: s }),
  /*
   * Hanging up: the handset turned face down, which is what every phone has
   * meant by it since they had cradles. A solid shape rather than the set's
   * usual stroked line — it sits on a red button at 26px and has to read as a
   * single mark at a glance, not as a drawing.
   */
  phoneOff: (s) => svg(html`
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.27396 8.94048C3.01237 7.88621 6.8401 6 12 6C17.1599 6 20.9876 7.88621 22.726 8.94048C23.7251 9.54634 24.1355 10.6912 23.9609 11.7514L23.5032 14.5308C23.2353 16.157 21.704 17.2467 20.101 16.9518L17.6354 16.4982C16.5887 16.3056 15.8888 15.2984 16.0637 14.2365L16.2935 12.8413C15.7061 12.4933 14.3714 11.9088 12 11.9088C9.62863 11.9088 8.29388 12.4933 7.70655 12.8413L7.93635 14.2365C8.11123 15.2984 7.41126 16.3056 6.36463 16.4982L3.89895 16.9518C2.29601 17.2467 0.764683 16.157 0.49684 14.5308L0.0390736 11.7514C-0.135542 10.6912 0.274923 9.54635 1.27396 8.94048ZM12 7.96961C7.30768 7.96961 3.82761 9.68804 2.2745 10.6299C2.04751 10.7676 1.8986 11.061 1.95897 11.4276L2.41674 14.207C2.50602 14.749 3.01646 15.1123 3.55077 15.014L6.01645 14.5603L5.76984 13.063C5.66906 12.4511 5.85834 11.6997 6.51793 11.2691C7.34118 10.7317 9.06148 9.93922 12 9.93922C14.9385 9.93922 16.6588 10.7317 17.4821 11.2691C18.1417 11.6997 18.3309 12.4511 18.2302 13.063L17.9836 14.5603L20.4492 15.014C20.9835 15.1123 21.494 14.749 21.5833 14.207L22.041 11.4276C22.1014 11.061 21.9525 10.7676 21.7255 10.6299C20.1724 9.68804 16.6923 7.96961 12 7.96961Z" />`,
    { size: s, fill: true }),
  micOff: (s) => svg(html`
    <path d="M15 10V5.5a3 3 0 0 0-5.9-.7M9 9.9v1.6a3 3 0 0 0 4.6 2.5" />
    <path d="M5.5 11.5a6.5 6.5 0 0 0 10.2 5.3M18.5 11.5v-.8M12 18v3.5" />
    <path d="M3 3l18 18" />`, { size: s }),
  screen: (s) => svg(html`
    <rect x="2.5" y="4" width="19" height="13" rx="2" />
    <path d="M8.5 21h7M12 17v4M9.5 11l2.5-2.5L14.5 11" />`, { size: s }),
  speaker: (s) => svg(html`
    <path d="M4 9v6h4l5 4V5L8 9H4Z" />
    <path d="M16.5 9.2a4 4 0 0 1 0 5.6M19 6.5a8 8 0 0 1 0 11" />`, { size: s }),
  bluetooth: (s) => svg(p('M7 7l10 10-5 4V3l5 4L7 17'), { size: s }),
  headphones: (s) => svg(html`
    <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
    <rect x="2.5" y="13.5" width="4.5" height="7" rx="2" />
    <rect x="17" y="13.5" width="4.5" height="7" rx="2" />`, { size: s }),
  // The handset speaker: sound held to the ear rather than thrown across a room.
  earpiece: (s) => svg(html`
    <rect x="6" y="2.5" width="12" height="19" rx="3" />
    <path d="M10 6.5h4" />`, { size: s }),
  cameraSwitch: (s) => svg(html`
    <path d="M15.5 9.5V8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1.5l5 3.2V6.3l-5 3.2Z" />
    <path d="M6.6 13.4a3 3 0 0 1 4.6-3.3M11.4 10.6a3 3 0 0 1-4.6 3.3" />
    <path d="M6.6 11.1v2.3h2.3M11.4 12.9v-2.3H9.1" />`, { size: s }),
  music: (s) => svg(html`
    <path d="M9 18V5.5l10-2V16" />
    <circle cx="6.5" cy="18" r="2.5" /><circle cx="16.5" cy="16" r="2.5" />`, { size: s }),
  doc: (s) => svg(html`
    <path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8.5L13.5 3Z" />
    <path d="M13.5 3v5.5H19M8.5 13h7M8.5 16.5h4.5" />`, { size: s }),
  gallery: (s) => svg(html`
    <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
    <circle cx="8.5" cy="10" r="1.6" />
    <path d="M3 16.5l4.8-4.3a2 2 0 0 1 2.7 0l4 3.6M14.2 14l1.9-1.7a2 2 0 0 1 2.7 0l2.7 2.4" />`, { size: s }),

  reply: (s) => svg(p('M9 14 4 9l5-5M4 9h9a7 7 0 0 1 7 7v3'), { size: s }),
  edit: (s) => svg(p('M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5 17v3ZM14.5 6.5l3 3'), { size: s }),
  trash: (s) => svg(p('M4 7h16M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M6.5 7l.8 12a2 2 0 0 0 2 1.9h5.4a2 2 0 0 0 2-1.9l.8-12'), { size: s }),
  copy: (s) => svg(html`<rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />`, { size: s }),
  pin: (s) => svg(p('M15.5 3.5 20.5 8.5 17 12l1 5-6-4.5L7 17l.5-5-4-2.5 5-3.5 7-2.5Z'), { size: s }),
  check: (s) => svg(p('M4.5 12.5 9 17 19.5 6.5'), { size: s }),
  // A filled seal with a tick — the operator's "verified" mark.
  verified: (s) => svg(html`
    <path fill="currentColor" stroke="none" d="M12 2.2l2.3 1.7 2.8-.3 1.2 2.6 2.6 1.2-.3 2.8L22 12l-1.7 2.3.3 2.8-2.6 1.2-1.2 2.6-2.8-.3L12 21.8l-2.3-1.7-2.8.3-1.2-2.6-2.6-1.2.3-2.8L2 12l1.7-2.3-.3-2.8 2.6-1.2 1.2-2.6 2.8.3Z" />
    <path d="M8.5 12.3 11 14.8l4.6-5" stroke="var(--verified-tick,#fff)" stroke-width="1.8" />`, { size: s }),
  /*
   * The three badges an operator can hand out, alongside `verified` above.
   *
   * Each is a different silhouette rather than the same shape in a different
   * colour: they are drawn at 15px next to a name, where colour alone is not
   * a difference — not on a bad screen, and not for the eight percent of men
   * who cannot tell the red one from the green one.
   */
  tester: (s) => svg(html`
    <path d="M10 3h4" />
    <path d="M10.5 3v5.6L5.8 17a2.3 2.3 0 0 0 2 3.4h8.4a2.3 2.3 0 0 0 2-3.4l-4.7-8.4V3" />
    <path d="M7.7 14.5h8.6" />`, { size: s }),
  donor: (s) => svg(
    p('M12 20.6 4.3 13a4.9 4.9 0 0 1 6.9-7l.8.8.8-.8a4.9 4.9 0 0 1 6.9 7Z'),
    { size: s, fill: true }
  ),
  translator: (s) => svg(html`
    <circle cx="12" cy="12" r="9" />
    <path d="M3.2 9.8h17.6M3.2 14.2h17.6" />
    <path d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z" />`, { size: s }),

  // A bot: a small robot head. Drawn next to its name like a badge.
  bot: (s) => svg(html`
    <rect x="4.5" y="8" width="15" height="11" rx="3" />
    <path d="M12 4.5V8" />
    <circle cx="12" cy="3.6" r="1" />
    <path d="M9.2 12.6v1.2M14.8 12.6v1.2" />
    <path d="M2.5 12.5v3M21.5 12.5v3" />`, { size: s }),
  // The command menu in a chat with a bot.
  slash: (s) => svg(html`
    <rect x="3.5" y="3.5" width="17" height="17" rx="4" />
    <path d="M14.5 7.5 9.5 16.5" />`, { size: s }),

  flag: (s) => svg(html`
    <path d="M4.5 21V4.2" />
    <path d="M4.5 5.2c4.5-2 7.5 1.6 12 0v8.6c-4.5 1.6-7.5-2-12 0V5.2Z" />`, { size: s }),

  checkDouble: (s) => svg(p('M1.5 12.5 6 17l8-8M10.5 15.5 12.5 17.5 22 8'), { size: s }),
  clock: (s) => svg(html`<circle cx="12" cy="12" r="9" /><path d="M12 7v5.2l3.2 2" />`, { size: s }),
  forwardMsg: (s) => svg(p('M15 14l5-5-5-5M20 9h-9a7 7 0 0 0-7 7v3'), { size: s }),

  file: (s) => svg(p('M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5ZM14 3v5h5'), { size: s }),
  image: (s) => svg(html`<rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="8.5" cy="9.5" r="1.7" /><path d="m3.5 17 5-5 4 4 3-2.5 5 4.5" />`, { size: s }),
  download: (s) => svg(p('M12 3.5v11M7.5 10.5 12 15l4.5-4.5M4 19h16'), { size: s }),
  play: (s) => svg(p('M7 4.5 19 12 7 19.5v-15Z'), { size: s, fill: true }),
  pause: (s) => svg(p('M8 4.5h3.2v15H8zM12.8 4.5H16v15h-3.2z'), { size: s, fill: true }),
  poll: (s) => svg(p('M6 20V10M12 20V4M18 20v-6'), { size: s }),
  location: (s) => svg(html`<path d="M20 10.5c0 5.5-8 12-8 12s-8-6.5-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10.5" r="2.8" />`, { size: s }),

  link: (s) => svg(p('M10 13a4.5 4.5 0 0 0 6.8.5l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.7 1.7M14 11a4.5 4.5 0 0 0-6.8-.5l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.7-1.7'), { size: s }),
  qr: (s) => svg(html`
    <rect x="3.5" y="3.5" width="6.5" height="6.5" rx="1.2" />
    <rect x="14" y="3.5" width="6.5" height="6.5" rx="1.2" />
    <rect x="3.5" y="14" width="6.5" height="6.5" rx="1.2" />
    <path d="M14 14h3v3h-3zM20.5 14v3M17.5 20.5h3M14 20.5h.01" />`, { size: s }),
  shield: (s) => svg(p('M12 3 4.5 6v6c0 4.7 3.2 8.3 7.5 9.5 4.3-1.2 7.5-4.8 7.5-9.5V6L12 3Z'), { size: s }),
  key: (s) => svg(html`<circle cx="8" cy="14" r="4.5" /><path d="m11.5 11 8-8M17 5.5l2.5 2.5M14.5 8l2.5 2.5" />`, { size: s }),
  bell: (s) => svg(p('M18 8.5a6 6 0 0 0-12 0c0 6-2.5 7.5-2.5 7.5h17S18 14.5 18 8.5ZM13.7 19.5a2 2 0 0 1-3.4 0'), { size: s }),
  bellOff: (s) => svg(html`
    <path d="M13.7 19.5a2 2 0 0 1-3.4 0M18 8.5a6 6 0 0 0-9.3-5M6.2 6.2A6 6 0 0 0 6 8.5c0 6-2.5 7.5-2.5 7.5h13" />
    <path d="M3 3l18 18" />`, { size: s }),
  archive: (s) => svg(html`<rect x="3" y="4" width="18" height="4.5" rx="1.3" /><path d="M4.8 8.5V19a1.5 1.5 0 0 0 1.5 1.5h11.4A1.5 1.5 0 0 0 19.2 19V8.5M10 12.5h4" />`, { size: s }),
  info: (s) => svg(html`<circle cx="12" cy="12" r="9" /><path d="M12 11v5.5M12 7.8h.01" />`, { size: s }),
  mail: (s) => svg(html`<rect x="3" y="5.5" width="18" height="13" rx="2.5" /><path d="m3.8 7 8.2 6 8.2-6" />`, { size: s }),
  logout: (s) => svg(p('M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9'), { size: s }),
  moon: (s) => svg(p('M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 0 0 11 11Z'), { size: s }),
  sun: (s) => svg(html`<circle cx="12" cy="12" r="4.2" /><path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4" />`, { size: s }),
  monitor: (s) => svg(html`<rect x="2.5" y="4" width="19" height="13" rx="2" /><path d="M8.5 21h7M12 17v4" />`, { size: s }),
  users: (s) => svg(html`
    <path d="M16 20v-1.5a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4V20" />
    <circle cx="9" cy="7" r="3.5" /><path d="M22 20v-1.5a4 4 0 0 0-3-3.87" /><path d="M16 3.6a4 4 0 0 1 0 7.75" />`, { size: s }),
  userPlus: (s) => svg(html`
    <path d="M14 20v-1.5a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4V20" />
    <circle cx="8" cy="7" r="3.5" /><path d="M18.5 8v6M21.5 11h-6" />`, { size: s }),
  crown: (s) => svg(p('M4 18h16M4.5 15 3 7l4.5 3L12 4l4.5 6L21 7l-1.5 8h-15Z'), { size: s }),
  eye: (s) => svg(html`<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" /><circle cx="12" cy="12" r="3" />`, { size: s }),
  eyeOff: (s) => svg(html`<path d="M10 5.7A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.3 4.1M6.3 7.9A17 17 0 0 0 2.5 12S6 18.5 12 18.5c1 0 2-.2 2.8-.5" /><path d="M3 3l18 18" />`, { size: s }),
  refresh: (s) => svg(p('M20.5 12a8.5 8.5 0 1 1-2.6-6.1M20.5 4v5h-5'), { size: s }),
  globe: (s) => svg(html`<circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18Z" />`, { size: s }),
  database: (s) => svg(html`<ellipse cx="12" cy="6" rx="8" ry="3.2" /><path d="M4 6v12c0 1.8 3.6 3.2 8 3.2s8-1.4 8-3.2V6M4 12c0 1.8 3.6 3.2 8 3.2s8-1.4 8-3.2" />`, { size: s }),
  bookmark: (s) => svg(p('M18 21 12 17l-6 4V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16Z'), { size: s }),
  smile: (s) => svg(html`<circle cx="12" cy="12" r="9" /><path d="M8.5 14a4.5 4.5 0 0 0 7 0" /><circle cx="9" cy="9.8" r=".9" fill="currentColor" stroke="none" /><circle cx="15" cy="9.8" r=".9" fill="currentColor" stroke="none" />`, { size: s }),
  block: (s) => svg(html`<circle cx="12" cy="12" r="9" /><path d="m5.6 5.6 12.8 12.8" />`, { size: s }),
  volume: (s) => svg(html`<path d="M4 9v6h4l5 4V5L8 9H4Z" /><path d="M16.5 9.2a4 4 0 0 1 0 5.6" />`, { size: s }),
  volumeOff: (s) => svg(html`<path d="M4 9v6h4l5 4V5L8 9H4Z" /><path d="m16 9.5 5 5M21 9.5l-5 5" />`, { size: s }),
  expand: (s) => svg(p('M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5'), { size: s })
}

export function iconFor (name, size) {
  const fn = Icon[name]
  return fn ? fn(size) : null
}
